<template>
  <div>
    <div class="opo02">
      <span class="opo03">标品库</span>
    </div>
    <div class="opo01">
      <div class="djt30">
        <div class="djt31">
          <input v-model="searchs" type="text" placeholder="输入名称进行搜索" placeholder-class="djt32" class="djt33">
          <img @click="seas" src="@/assets/images/sea01.png" alt="" class="djt34">
        </div>
      </div>
      <div style="width: 50%;display: flex;justify-content: flex-end">
        <div class="djt02" style="margin-right: 20px" @click="xjsp">
          <img src="@/assets/images/qw2.png" class="djt03" alt="">
          <p class="djt04">新建商品</p>
        </div>
        <div class="djt02" @click="spsh">
          <img src="@/assets/images/qw1.png" class="djt03" alt="">
          <p class="djt04">商品审核</p>
        </div>
      </div>
    </div>
    <div class="djt05">
      <div class="djt06">
        <div class="djt26k">图片</div>
        <div class="djt26k">名称</div>
        <div class="djt26k">编码</div>
        <div class="djt26k">规格</div>
        <div class="djt26k">状态</div>
      </div>
      <el-skeleton animated :loading="loading" :count="6">
        <template slot="template">
          <el-skeleton-item variant="p" style="width: 100%;height: 80px;" />
        </template>
        <template>
          <div class="djt09" v-for="(item,index) in data.dataList" :key="'lis'+index">
            <div class="djt2711" style="display: flex;justify-content: center;">
              <img :src="item.url" alt="" class="bpk01">
            </div>
            <div class="djt2711" :title="item.name">{{item.name}}</div>
            <div class="djt2711" :title="item.code">{{item.code}}</div>
            <div class="djt2711" :title="item.specs">{{item.specs}}</div>
            <div class="djt2711" style="color: #FFC400" v-if="item.state == 1">待审核</div>
            <div class="djt2711" style="color: #2176FA" v-if="item.state == 2">审核通过</div>
            <div class="djt2711" style="color: #FA2121" v-if="item.state == 3">审核不通过</div>
          </div>
        </template>
      </el-skeleton>
      <div class="djt09" style="border-bottom: none;margin-top: 5px;">
        <el-pagination
          @current-change="toPage"
          background
          :page-size="8"
          :page-count="data.totalPage"
          layout="prev, pager, next"
          class="djt29"
        >
        </el-pagination>
      </div>
    </div>
    <xc-model :loading="isModel" title="添加商品" :is_buttom="false" @cancel="cancel">
      <div slot="mbody">
        <div class="djt17">
          <div class="djt18">
            <div class="djt19">名称：</div>
            <input v-model="name" type="text" placeholder="请输入名称" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 10px">
            <div class="djt19" style="opacity: 0;line-height: 0">名称：</div>
            <p style="width: 400px;font-size: 15px;color: red">* 建议标品名称不要重复</p>
          </div>
          <div class="djt18" style="margin-top: 5px">
            <div class="djt19">编码：</div>
            <input v-model="num" type="text" placeholder="请输入编码" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">规格：</div>
            <input v-model="spec" type="text" placeholder="请输入规格" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">图片：</div>
            <div class="bpk02">
              <img src="@/assets/images/qw3.png" class="bpk03" alt="" v-if="imageUrl == ''">
              <img :src="imageUrl" class="bpk03" alt="" v-else>
              <Upload
                class="bpk04"
                :on-success="succGz"
                :multiple="false"
                type="drag"
                action="/load/gyy/api/uploadfile">
                <div>
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>点击或者拖拽以上传图片</p>
                </div>
              </Upload>
            </div>
          </div>
          <div class="djt21">
            <div class="djt22" @click="shre">确认</div>
            <div class="djt22" style="margin-left: 50px" @click="cancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from "@/api/user";
  import util from '@/util/util';
  export default {
    name: "djgbpk",
    data(){
      return{
        searchs:'',
        isModel:false,
        loading:true,
        pageSize:7,
        page:1,
        data:[],
        name:'',
        num:'',
        spec:'',
        imageUrl: ''
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
    },
    mounted() {
      let data = {
        page:1,
        pageSize:me.pageSize,
      }
      httpUser.getgoodscommlist(data).then(res => {
        me.data = res.data;
        me.loading = false;
        console.log(res);
      })
    },
    methods:{
      spsh(){
        me.$router.push({path:'/djgsp',query:{}});
      },
      shre(){//确定提交商品
        if (me.name == '' || me.name.indexOf(' ') != -1) {
          me.$message.error('请正确输入商品名称');
          return false;
        }
        if (me.num == '' || me.num.indexOf(' ') != -1) {
          me.$message.error('请正确输入商品编号');
          return false;
        }
        if (me.spec == '' || me.spec.indexOf(' ') != -1) {
          me.$message.error('请正确输入商品规格');
          return false;
        }
        if (me.imageUrl == '') {
          me.$message.error('请先上传商品图片');
          return false;
        }
        let data = {
          name:me.name,
          code:me.num,
          specs:me.spec,
          state:1,
          url:me.imageUrl,
        }
        httpUser.addorupdategoodscomm(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                page:me.page,
                pageSize:me.pageSize,
              }
              httpUser.getgoodscommlist(data).then(res => {
                me.data = res.data;
                me.isModel = false;
                me.name = '';
                me.num = '';
                me.spec = '';
                me.$Loading.finish();
                me.$message.success('提交申请成功');
                console.log(res);
              })
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
            case "1001":
              me.$Loading.error();
              me.$message.error('编号重复');
              break;
          }
        })
      },
      succGz(e){//文件上传成功后的钩子
        me.imageUrl = e.data;
      },
      xjsp(){//新建商品
        me.isModel = true;
      },
      seas(){
        me.$Loading.start();
        let data = {
          keyword:me.searchs,
          page:1,
          pageSize:me.pageSize,
        }
        httpUser.getgoodscommlist(data).then(res => {
          me.$Loading.finish();
          me.data = res.data;
        })
      },
      toPage(e){//分页
        me.loading = true;
        let data = {
          page:e,
          pageSize:me.pageSize,
        }
        if (me.searchs != '') {
          me.$set(data,'keyword',me.searchs);
        }
        me.page = e;
        httpUser.getgoodscommlist(data).then(res => {
          me.data = res.data;
          me.loading = false;
        })
      },
      cancel(){//添加框点击返回
        me.isModel = false;
      },
    }
  }
</script>

<style scoped>
  @import "bpk.css";
</style>